module.exports = __webpack_public_path__ + "static/media/bchains.360784c4.png";